import Swal from "sweetalert2";
import store from "src/page/store";
import { setShowSubscriptionModal } from "src/page/plans/plansSlice";

interface ErrorConfig {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  showCancelButton?: boolean;
  onConfirm?: () => void;
}

export const errorMapping: Record<string, ErrorConfig> = {
  // Authorization denial from the AppSync authorizer (valid session, but the
  // role isn't permitted). Shown as "access denied" — never a logout.
  UnauthorizedException: {
    title: "Access denied",
    message:
      "You don't have permission to do this. Please ask your organisation's administrator for access.",
    confirmButtonText: "Go back",
    onConfirm: () => {
      window.history.back();
    }
  },
  LIMIT_EXCEEDED: {
    title: "Limit Exceeded",
    message: "Your subscription plan limits the action. Please upgrade your plan to proceed.",
    confirmButtonText: "Upgrade Now",
    cancelButtonText: "Cancel",
    showCancelButton: true,
    onConfirm: () => {
      const dispatch = store.dispatch;

      dispatch(setShowSubscriptionModal(true));
    }
  },
  ENTITLEMENT_NOT_ACTIVE: {
    title: "Subscription Required",
    message: "You haven't purchased a subscription yet. Please purchase a subscription plan to proceed.",
    confirmButtonText: "View Plans",
    cancelButtonText: "Cancel",
    showCancelButton: true,
    onConfirm: () => {
      const dispatch = store.dispatch;

      dispatch(setShowSubscriptionModal(true));
    }
  }
};

export const showErrorAlert = (errorType: string, fallbackMessage: string) => {
  const errorConfig = errorMapping[errorType];

  if (errorConfig) {
    Swal.fire({
      title: errorConfig.title,
      text: errorConfig.message,
      icon: "warning",
      showCancelButton: errorConfig.showCancelButton ?? false,
      confirmButtonText: errorConfig.confirmButtonText ?? "OK",
      cancelButtonText: errorConfig.cancelButtonText ?? "Cancel"
    }).then((result) => {
      if (result.isConfirmed && errorConfig.onConfirm) {
        errorConfig.onConfirm();
      }
    });
  } else {
    Swal.fire({
      title: "Error",
      text: fallbackMessage,
      icon: "error",
      confirmButtonText: "OK"
    });
  }
};
